import {
    FETCH_PROFESSIONSV2_FULFILLED,
    FETCH_PROFESSIONSV2_REJECTED,
    FETCH_PROFESSIONSV2_PENDING,
    RESET_PROFESSIONSV2,
  } from "../actions/professions";
  
  const initialState = {
    done: false,
    error: false,
    spinner: false,
    professions: [], // Başlangıç değeri boş array
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PROFESSIONSV2_PENDING:
        return {
          ...state,
          done: false,
          error: false,
          spinner: true, // Yüklenme durumu
        };
  
      case FETCH_PROFESSIONSV2_FULFILLED:
        return {
          ...state,
          professions: action.payload, // API'den gelen veriler state'e ekleniyor
          done: true,
          error: false,
          spinner: false, // Yüklenme tamamlandı
        };
  
      case FETCH_PROFESSIONSV2_REJECTED:
        return {
          ...state,
          error: action.payload, // Hata state'e kaydediliyor
          done: false,
          spinner: false, // Yüklenme tamamlandı (hatalı)
        };
  
      case RESET_PROFESSIONSV2:
        return {
          ...initialState, // State resetleniyor
        };
  
      default:
        return state; // Varsayılan olarak mevcut state döndürülür
    }
  };
  